// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"filter-pane__placeholder","placeholder-over":"filter-pane__placeholder-over","placeholder-active":"filter-pane__placeholder-active","placeholder-disabled":"filter-pane__placeholder-disabled","filter-shelf":"filter-pane__filter-shelf","filter-pane":"filter-pane__filter-pane"};


//////////////////
// WEBPACK FOOTER
// ./src/components/filter-pane/filter-pane.scss
// module id = 1222
// module chunks = 0